/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Simple_Newreleases1Inputs */

const id_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilis Baru`)
};

const ms_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluaran Baharu`)
};

const da_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nye Udgivelser`)
};

const de_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuerscheinungen`)
};

const en_us2_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Releases`)
};

const es_es2_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevos Lanzamientos`)
};

const es_mx2_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevos lanzamientos`)
};

const fil_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagong Release`)
};

const fr_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelles sorties`)
};

const it_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuove Uscite`)
};

const hu_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Új megjelenések`)
};

const nl_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe Releases`)
};

const no_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nye utgivelser`)
};

const pl_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowe premiery`)
};

const pt_br2_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Releases`)
};

const pt_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novos Lançamentos`)
};

const ro_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lansări noi`)
};

const fi_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uudet julkaisut`)
};

const sv_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nya släpp`)
};

const vi_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản phát hành mới`)
};

const tr_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni Çıkanlar`)
};

const cs_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová vydání`)
};

const bg_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нови издания`)
};

const ru_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новые релизы`)
};

const uk_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нові релізи`)
};

const ar_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإصدارات الجديدة`)
};

const hi_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नए रिलीज़`)
};

const th_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การวางจำหน่ายใหม่`)
};

const ja_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新着リリース`)
};

const zh_cn2_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Releases`)
};

const zh_hant1_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Releases`)
};

const ko_notifications_simple_newreleases1 = /** @type {(inputs: Notifications_Simple_Newreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`신규 출시`)
};

/**
* | output |
* | --- |
* | "New Releases" |
*
* @param {Notifications_Simple_Newreleases1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_newreleases1 = /** @type {((inputs?: Notifications_Simple_Newreleases1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Newreleases1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_newreleases1(inputs)
	if (locale === "ms") return ms_notifications_simple_newreleases1(inputs)
	if (locale === "da") return da_notifications_simple_newreleases1(inputs)
	if (locale === "de") return de_notifications_simple_newreleases1(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_newreleases1(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_newreleases1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_newreleases1(inputs)
	if (locale === "fil") return fil_notifications_simple_newreleases1(inputs)
	if (locale === "fr") return fr_notifications_simple_newreleases1(inputs)
	if (locale === "it") return it_notifications_simple_newreleases1(inputs)
	if (locale === "hu") return hu_notifications_simple_newreleases1(inputs)
	if (locale === "nl") return nl_notifications_simple_newreleases1(inputs)
	if (locale === "no") return no_notifications_simple_newreleases1(inputs)
	if (locale === "pl") return pl_notifications_simple_newreleases1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_newreleases1(inputs)
	if (locale === "pt") return pt_notifications_simple_newreleases1(inputs)
	if (locale === "ro") return ro_notifications_simple_newreleases1(inputs)
	if (locale === "fi") return fi_notifications_simple_newreleases1(inputs)
	if (locale === "sv") return sv_notifications_simple_newreleases1(inputs)
	if (locale === "vi") return vi_notifications_simple_newreleases1(inputs)
	if (locale === "tr") return tr_notifications_simple_newreleases1(inputs)
	if (locale === "cs") return cs_notifications_simple_newreleases1(inputs)
	if (locale === "bg") return bg_notifications_simple_newreleases1(inputs)
	if (locale === "ru") return ru_notifications_simple_newreleases1(inputs)
	if (locale === "uk") return uk_notifications_simple_newreleases1(inputs)
	if (locale === "ar") return ar_notifications_simple_newreleases1(inputs)
	if (locale === "hi") return hi_notifications_simple_newreleases1(inputs)
	if (locale === "th") return th_notifications_simple_newreleases1(inputs)
	if (locale === "ja") return ja_notifications_simple_newreleases1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_newreleases1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_newreleases1(inputs)
	return ko_notifications_simple_newreleases1(inputs)
});
export { notifications_simple_newreleases1 as "notifications.simple.newReleases" }